import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'hoot-front';

  ngOnInit(): void {
   Swal.fire({
      title: 'Error',
      text: 'Se han proporcionado datos incorrectos o el QR no es válido',
      icon: 'error',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCloseButton: false});
  }
  
}
